/** Iniciales (máx. 2) para avatares de texto, a partir de nombre o email. */
export function iniciales(nombre?: string | null, email?: string | null): string {
  const base = (nombre ?? '').trim() || (email ?? '').trim();
  if (!base) return '·';
  const partes = base.split(/\s+/).filter(Boolean);
  if (partes.length >= 2) return (partes[0][0] + partes[1][0]).toUpperCase();
  return base.slice(0, 2).toUpperCase();
}
